export const GENERAL_STATUS_STYLE = {
  CREATED: 'bg-purple-subtle text-purple-secondary',
  ACTIVE: 'bg-green-subtle text-green-success',
  INACTIVE: 'bg-red-subtle text-red-secondary',
  EXPIRED: 'bg-grey-subtle text-grey-dark',
  CONFIRMED: 'bg-blue-light text-blue-light bg-opacity-10',
  PAID: 'text-green-secondary bg-green-secondary bg-opacity-10',
  UNPAID: 'text-yellow-secondary bg-yellow-secondary bg-opacity-10',
  REFUND: 'text-red-primary bg-red-primary bg-opacity-10',
  PARTIAL_REFUND: 'text-red-primary bg-red-primary bg-opacity-10',
  CANCELED: 'text-grey-dark bg-grey-dark bg-opacity-10',
  PUBLISHED: 'text-green-success bg-green-subtle',
  DRAFT: 'text-blue-light bg-blue-subtle',
  ARCHIVED: 'text-red-secondary bg-red-subtle',
  PENDING: 'text-blue-light bg-blue-light bg-opacity-10',
  REJECTED: 'text-red-primary bg-red-primary bg-opacity-10',
}